'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.snackbarInitialState = snackbarInitialState;
exports.snackbarStyle = snackbarStyle;

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var polyglot = new _nodePolyglot2.default({
  locale: 'fr',
  phrases: require('./../locales/fr/app.js')
});

function snackbarInitialState() {
  return {
    action: polyglot.t('snackbar.undo'),
    dismissAfter: 25000,
    id: 0,
    isActive: false,
    message: '',
    currentAction: ''
  };
}

function snackbarStyle() {
  return {
    bar: {
      width: '100%',
      left: '0',
      bottom: '-8rem',
      margin: '0 auto',
      padding: '2rem',
      backgroundColor: '#FBE89E',
      color: '#474747',
      font: 'inherit',
      borderRadius: 0,
      boxShadow: 'none',
      textAlign: 'center',
      fontSize: '17px'
    },
    active: {
      bottom: '0',
      left: '0'
    },
    action: {
      marginLeft: '1.5rem',
      color: '#474747',
      font: 'inherit',
      letterSpacing: '0',
      fontWeight: '600',
      fontSize: '13px',
      border: '2px solid rgba(71, 71, 71, 0.2)',
      padding: '0.5rem 1rem',
      borderRadius: '0'
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/snackbar.js
// module id = 2307
// module chunks = 0